import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  totalCustomers: 'analytic/getTotalConsumers',
  totalUsers: 'analytic/getTotalUsers',
  verifiedStores: 'analytic/getVerifiedStores',
  getAnalyticsMapsData: '/analytic/getAnalyticsMapsData',
  getPlusFeaturesData: '/analytic/getPlusFeatureData',
  getCustomerAnalytic: '/analytic/getEventAnalytic',
  getActiveUser: '/analytic/getActiveUser',
  getStateAnalytics: '/analytic/getUsersByState',
  getAreaAnalytics: '/analytic/getUsersByArea',
  getTrafficAnalaytic: '/analytic/getTrafficAnalaytic',
  getPlusFeatureAnalytic: '/analytic/getPlusFeatureAnalytic',
  getAdvertisementAnalytic: '/analytic/getAdvertisementAnalytic',
  getPlusFeatureAnalyticByCity: '/analytic/getPlusFeatureAnalyticByCity',
  getCategoriesAnalytic: '/analytic/getCategoriesAnalytic',
  getPlusFeatureAnalyticTypes: '/analytic/getPlusFeatureAnalyticTypes',
  getPartnerAnalytic: '/analytic/getPartnerAnalytic',
  getPartnerUsers: '/analytic/getActivePartnerUsers',
  createPartnerUsers: '/analytic/createPartnerAnalytic',
  getBuyVehicleImpression: '/analytic/getVehicleImpression',
  getBuyVehicleAll: '/analytic/getBuyVehicleAll'
};

export const getTotalCustomersApi = createAsyncThunk('serviceplug/getTotalCustomersApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.totalCustomers);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    console.log('error in api', error);
    return thunkApi.rejectWithValue(error);
  }
});

export const getTotalUsersApi = createAsyncThunk('serviceplug/getTotalUsersApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.totalUsers);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getVerifiedStoresApi = createAsyncThunk('serviceplug/getVerifiedStoresApi', async (params, thunkApi) => {
  try {
    console.log(params, 'params');
    const response = await axios.get(urls.verifiedStores, { params });
    if (response.data?.result || response?.data) {
      return response.data.result || response?.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAnalyticsMapsDataApi = createAsyncThunk(
  'serviceplug/getAnalyticsMapsDataApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.post(urls.getAnalyticsMapsData, params);
      if (Array.isArray(response.data?.result)) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getPlusFeaturesDataApi = createAsyncThunk(
  'serviceplug/getPlusFeaturesDataApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.post(urls.getPlusFeaturesData, params);
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getCustomerAnalyticApi = createAsyncThunk('servicePlug/getCustomerAnalytic', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getCustomerAnalytic}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getActiveUserApi = createAsyncThunk('servicePlug/getActiveUser', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getActiveUser}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getStateAnalyticsApi = createAsyncThunk('servicePlug/getStateAnalytics', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getStateAnalytics}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAreaAnalyticsApi = createAsyncThunk('servicePlug/getAreaAnalytics', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getAreaAnalytics}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getTrafficAnalayticApi = createAsyncThunk('servicePlug/getTrafficAnalaytic', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getTrafficAnalaytic}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getPlusFeatureAnalyticApi = createAsyncThunk(
  'servicePlug/getPlusFeatureAnalyticApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getPlusFeatureAnalytic}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getAdvertisementAnalyticApi = createAsyncThunk(
  'servicePlug/getAdvertisementAnalytic',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getAdvertisementAnalytic}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPlusFeatureAnalyticByCityApi = createAsyncThunk(
  'servicePlug/getPlusFeatureAnalyticByCity',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getPlusFeatureAnalyticByCity}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getCategoriesAnalyticApi = createAsyncThunk(
  'servicePlug/getCategoriesAnalytic',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getCategoriesAnalytic}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPlusFeatureAnalyticTypesApi = createAsyncThunk(
  'servicePlug/getPlusFeatureAnalyticTypes',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getPlusFeatureAnalyticTypes}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPartnerAnalyticApi = createAsyncThunk('servicePlug/getPartnerAnalytic', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getPartnerAnalytic}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const createPartnerUsersApi = createAsyncThunk('servicePlug/createPartnerUsersApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createPartnerUsers}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getPartnerUsersApi = createAsyncThunk('servicePlug/getPartnerUsersApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getPartnerUsers}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getBuyVehicleImpressionApi = createAsyncThunk(
  'servicePlug/getBuyVehicleImpression',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getBuyVehicleImpression}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getBuyVehicleAllApi = createAsyncThunk('servicePlug/getBuyVehicleAll', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.getBuyVehicleAll}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
